import React from "react";

import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

function RunJobAsComponent({
  participants,
  selectedUser,
  error,
  editable,
  nonEditableValue,
  handleChange,
  handleRunUnderMyName,
  ...props
}) {
  return (
    <FormControl {...props} error={error}>
      {editable ? (
        <>
          <InputLabel required>Run the job as</InputLabel>
          <Select
            value={selectedUser || ""}
            label="Run the job as"
            required
            MenuProps={{ sx: { height: "220px" } }}
            onChange={(e, { props }) =>
              handleChange(e, { runJobAsUserId: e.target.value, runJobAsUserFullName: props.fullName })
            }
          >
            {participants.map((participant) => (
              <MenuItem key={participant.User_id} value={participant.User_id} fullName={participant.FullName}>
                {participant.FullName}
              </MenuItem>
            ))}
          </Select>
        </>
      ) : (
        <TextField value={nonEditableValue} fullWidth required label="Run the job as" disabled error={error} />
      )}
      {error ? (
        <>
          <FormHelperText sx={{ margin: "3px 0 0" }}>
            Job cannot be ran under the previously selected user's name
          </FormHelperText>
          <Typography
            padding={0}
            variant="subtitle2"
            sx={{ color: "#065CCF", cursor: "pointer", textDecoration: "underline" }}
            onClick={handleRunUnderMyName}
          >
            Run under my name
          </Typography>
        </>
      ) : (
        ""
      )}
    </FormControl>
  );
}

export default React.memo(RunJobAsComponent);
